import React from 'react';
import { LogoWithText } from '../Logos';

import FiveHundredError from './FiveHundredError';

import './five-hundred-error-page.scss';

const FiveHundredErrorPage = () => (
  <div className="sm-five-hundred-error-page">
    <div className="sm-five-hundred-error-page__error-message-wrapper">
      <a href="/" className="sm-five-hundred-error-page__error-logo">
        <LogoWithText />
      </a>
      <FiveHundredError />
    </div>
  </div>
);

export default FiveHundredErrorPage;
